import React, {useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import Title from "../../../components/Title";
import FilterButton, {FilterGroup} from "../../../components/FilterButton";
import {DateRangeFilterButton} from "../../../components/DateRangeFilterButton";
import CmpAnalyticsDashboardContainer, {ConsentLayoutTab} from "../../../components/cmp/analytics/CmpAnalyticsDashboardContainer";
import {Loader} from "../../../components/components";
import {useHistory, useParams} from "react-router-dom";
import useCmpAnalytics from "../../api_hooks/useCmpAnalytics";
import {useGetAppQuery} from "../../../api/appApiSlice";


export default function CmpAppAnalytics(props) {
  const { t } = useTranslation();
  const {appId} = useParams();
  const history = useHistory()
  const configurable = {type: 'app', id: appId}
  const {data: app = {}, isAppSuccess} = useGetAppQuery({appId})
  const {setFilter, loaderProps, data, analytics, kpis} = useCmpAnalytics({configurable})

  return (
    <>
      <Title main={app.name} sub="CMP Configuration" onBack={()=>(history.push(`/publishers/${app.publisher.publisherId}/cmp/configuration`))}/>
      <FilterGroup fireOnChangeAtMount={false} onChange={setFilter} >
        <DateRangeFilterButton
          startDate={data.startDate}
          endDate={data.endDate}
        />
        <FilterButton
          title={t("cmp.analytics.tcfVersion")}
          options={[1, 2]}
          search={false}
          includeAll={true}
          name="tcf"/>
        <FilterButton
          title={"SDK"}
          options={data.sdkVersions}
          search={true}
          includeAll={true}
          name="sdk"/>
        <FilterButton
          title={"layout"}
          options={data.layoutVersions}
          search={true}
          includeAll={true}
          name="layout"/>
      </FilterGroup>
      <Loader {...loaderProps}>
        <CmpAnalyticsDashboardContainer kpis={kpis} analytics={analytics}>
          <ConsentLayoutTab as="layout" icon="layout"
                            dataByLayout={analytics.dataByLayout}
                            dataByLayoutByDay={analytics.dataByLayoutByDay}
                            requestsByLayout={analytics.requestsByLayout}/>
        </CmpAnalyticsDashboardContainer>
      </Loader>
    </>
  )
}
